import React, {useEffect} from 'react';
import {useAuth} from "../../../context";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import {useGetJson, usePostJson} from "../../../hooks";
import {endpoints, regex} from "../../../utils2";
import * as yup from "yup";
import {Alert, Button, OverlayTrigger, Stack, Tooltip} from "react-bootstrap";
import {AdminUserAlert, ColumnizeText, OurAlert, PageTitle, PasswordButton, SingleText} from "../../_components";
import {Formik, Form as FormikForm} from "formik";
import {WhiteCard} from "../_components/WhiteCard";

export function AddEditStreamPlayback() {
    const {userId, authToken} = useAuth()
    const {uid, did, pid} = useParams()
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (pid === "new" && location.state == null) {
            navigate(`/device/${uid}`)
        }
    }, [location])

    const edit = pid !== "new"

    const [ev, loadingEvent, errorEvent, clearErrorEvent] = useGetJson(pid === "new" ? null : endpoints.event.get(pid), authToken?.jwt)
    const event = ev?.data
    const config2 = event?.config2

    const [submitFormAdd, _, loadingAdd, errorAdd, clearErrorAdd] = usePostJson(endpoints.event.add(did), authToken?.jwt)

    const [submitFormEdit, _2, loadingEdit, errorEdit, clearErrorEdit] = usePostJson(endpoints.event.edit(pid), authToken?.jwt)

    const validationSchema = yup.object().shape({
        main_host: yup.string().required("Radio is required")
            .matches(regex.url_pattern, "Invalid URL format"),
        main_timeout: yup.number().typeError("Timeout must be a valid number").required("Timout is required").min(10, "Timeout must be at least 15")
            .max(120, "Timeout must be at most 120"),
        fail_host: yup.string().matches(regex.url_pattern, "Invalid URL format"),
        fail_timeout: yup.number().typeError("Timeout must be a valid number").required("Timout is required").min(10, "Timeout must be at least 15")
            .max(120, "Timeout must be at most 120"),
        delay: yup.number().required("Delay is required"),
    })

    const initialValues = {
        // Playback
        main_host: config2?.main_host || "",
        main_timeout: config2?.main_timeout || 15,
        main_username: config2?.main_username || "",
        main_password: config2?.main_password || "",
        fail_host: config2?.fail_host || "",
        fail_timeout: config2?.fail_timeout || 15,
        fail_username: config2?.fail_username || "",
        fail_password: config2?.fail_password || "",
        delay: config2?.delay || 15,

    }

    function handleOnSubmit(values, action) {
        const payload = {...location.state, name: location.state?.name || event?.name, playback: values}
        if (edit) {
            submitFormEdit(payload, json => {
                action.setSubmitting(false)
                navigate(`/device/${uid}/${did}/config`)
            })
        } else {
            submitFormAdd(payload, jsonTime => {
                action.setSubmitting(false)
                navigate(location.state.steps[2])
            })
        }
    }

    if (edit && loadingEvent) {
        return <div>Loading...</div>;
    }

    // const backTo = -1
    const backTo = () => navigate(location.state?.steps[0], {state: location.state})


    return <Stack>
        <AdminUserAlert/>
        {/*<OurAlert variant="info" show={userId !== uid} msg={`Watch out, you are managing user ID ${uid}.`}/>*/}
        <Alert variant="danger" show={errorEvent} dismissible onClose={clearErrorEvent}>{errorEvent}</Alert>
        <Alert variant="danger" show={errorAdd} dismissible onClose={clearErrorAdd}>{errorAdd}</Alert>
        <Alert variant="danger" show={errorEdit} dismissible onClose={clearErrorEdit}>{errorEdit}</Alert>

        <PageTitle title="Set Playback">{edit ? `Edit ${event?.name}` : `Add`}.</PageTitle>

        <Formik validationSchema={validationSchema} onSubmit={handleOnSubmit} initialValues={initialValues} enableReinitialize={true}>
            {({isSubmitting, resetForm}) => (
                <FormikForm>

                    <PlaybackStreamForm/>

                    <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                        {/*<Button as={Link} variant="link" to={backTo}>Go back</Button>*/}
                        <Button variant="link" onClick={backTo}>Go back</Button>
                        <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                        <Button type="submit" variant="primary" disabled={isSubmitting}>{edit ? "Edit" : "Add"}</Button>
                    </Stack>

                </FormikForm>
            )}
        </Formik>


    </Stack>

}

export function PlaybackStreamForm() {
    return <div>
        <WhiteCard>
            <div className="fs-6 fw-semibold my-2">Stream From</div>
            <Stack direction="horizontal" className="flex-wrap" gap={2}>
                <SingleText name="main_host" label="Radio" maxLength="128" placeholder="https://" className="flex-grow-1"/>
                <OverlayTrigger placement="top" overlay={<Tooltip>Time in seconds before the connection is considered failed</Tooltip>}>
                    <SingleText name="main_timeout" label="Timeout" postfix="sec" className=""/>
                </OverlayTrigger>
            </Stack>

            <ColumnizeText className="my-2">
                <SingleText name="main_username" label="Username" autoComplete="off"/>
                <PasswordButton name="main_password" label="Password" position="right" autoComplete="new-password"/>
            </ColumnizeText>
        </WhiteCard>

        <WhiteCard>
            <div className="fs-6 fw-semibold my-2">Stream Fail Over</div>
            <Stack direction="horizontal" className="flex-wrap" gap={2}>
                <SingleText name="fail_host" label="Radio" maxLength="128" placeholder="https://" className="flex-grow-1"/>
                <OverlayTrigger placement="top" overlay={<Tooltip>Time in seconds before the connection is considered failed</Tooltip>}>
                    <SingleText name="fail_timeout" label="Timeout" postfix="sec" className=""/>
                </OverlayTrigger>
            </Stack>

            <ColumnizeText className="my-2">
                <SingleText name="fail_username" label="Username"/>
                <PasswordButton name="fail_password" label="Password" position="right"/>
            </ColumnizeText>
        </WhiteCard>

        <WhiteCard>
            <div className="fs-6 fw-semibold my-2">Sync Delay</div>
            <SingleText name="delay" label="Delay" postfix="msec" className=""/>
        </WhiteCard>

    </div>
}